import { registerSW } from 'virtual:pwa-register';

/**
 * Injetado pelo Vite no build (ver `define` em packages/web/vite.shared.ts).
 * Declarado aqui dentro, e não num .d.ts do pacote: os tsconfig dos apps
 * só incluem a própria pasta `src`, então um ambiente global daqui nunca
 * seria carregado por eles.
 */
declare const __BUILD_ID__: string | undefined;

/**
 * Mantém o app atualizado.
 *
 * `autoUpdate` sozinho não resolve no iPhone: reabrir o PWA pelo
 * multitarefa restaura a página em vez de navegar, e o navegador nem
 * chega a perguntar se existe versão nova. O app fica preso numa versão
 * antiga indefinidamente — e nenhum deploy chega em quem já instalou.
 *
 * Aqui a checagem é explícita: toda vez que o app volta para a frente, e
 * a cada poucos minutos com ele aberto.
 */
export function setupAutoUpdate(): void {
  const updateSW = registerSW({
    immediate: true,

    onNeedRefresh() {
      // Aplica e recarrega. Sem diálogo: não há nada a decidir, e um
      // motorista com o celular no painel não vai ler um aviso.
      void updateSW(true);
    },

    onRegisteredSW(_url, registration) {
      if (!registration) return;

      const check = () => {
        if (document.visibilityState === 'visible') void registration.update();
      };

      document.addEventListener('visibilitychange', check);
      window.addEventListener('focus', check);
      // Rede volta depois de um túnel: momento natural para conferir.
      window.addEventListener('online', check);

      const timer = setInterval(check, 5 * 60_000);
      window.addEventListener('pagehide', () => clearInterval(timer));
    },
  });
}

/** Identificador do build, para saber qual versão está no aparelho. */
export const BUILD_ID: string =
  typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';
